import { useState, useEffect, useRef, useMemo } from "react";
import { Button, Col, Modal, Nav, Row, Tab, Form } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { debounce } from "lodash";

import { api_without_cancellation } from "../../../api/api";
import AutoCompleteSearch from "../../Insurance/AutoCompleteSearch";
import {
  formatCalendarDateForInput,
  formatPhoneNumber,
  getCaseId,
  getClientId,
  inputCurrencyFormat2,
} from "../../../Utils/helper";

import GenericContactTabForHookForm from "./GenericContactTabForHookForm";

function EditReportModal({
  report,
  handleClose,
  onFetchReports = () => {},
  show,
  activeTab,
  onShowDeleteConfirmPopup,
}) {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const methods = useForm();
  const { reset, handleSubmit, register, setValue, watch } = methods;

  const [searchResults, setSearchResults] = useState([]);
  // const [filteredResults, setFilteredResults] = useState([]);
  // const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [statesAbrs, setStatesAbrs] = useState([]);
  const [reportTypes, setReportTypes] = useState([]); // all reports in db
  const reportTypeRef = useRef(null);
  const [reportTypeDropdown, setReportTypeDropdown] = useState(false);
  // const selectedState = useRef("AZ");
  const dummy = watch("is_blocked");

  // const handleInputChange = (e) => {
  //   const inputValue = e.target.value.toLowerCase();
  //   if (inputValue !== "") {
  //     const filtered = searchResults.filter((result) => {
  //       const agency = result.name ? result.name.toLowerCase() : "";
  //       const address = result.address ? result.address.toLowerCase() : "";
  //       const address1 = result.address1 ? result.address1.toLowerCase() : "";
  //       const city = result.city ? result.city.toLowerCase() : "";
  //       const state = result.state ? result.state.toLowerCase() : "";

  //       return (
  //         agency.startsWith(inputValue) ||
  //         address.startsWith(inputValue) ||
  //         address1.startsWith(inputValue) ||
  //         city.startsWith(inputValue) ||
  //         state.startsWith(inputValue)
  //       );
  //     });

  //     setFilteredResults(filtered);
  //     setIsFiltersOpen(true);
  //   } else {
  //     setFilteredResults([]);
  //   }
  // };

  const fetchStatesData = async () => {
    const response = await api_without_cancellation.get(`${origin}/api/states/`);
    if (response.status === 200) {
      setStatesAbrs(response.data);
    }
  };

  // const fetchFilterReportData = async () => {
  //   const response = await api.get(`${origin}/api/search_filter_reports/`);
  //   setSearchResults(response.data);
  // };
  const [selectedReportTypeID, setSelectedReportTypeID] = useState(0);
  const [reportSearchInput, setReportSearchInput] = useState("");
  const controllerRef = useRef(null);

  const fetchFilterReportData = async (search) => {
    try {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      const controller = new AbortController();
      controllerRef.current = controller;

      const params = { query: search };

      const response = await api_without_cancellation.get("/api/search_filter_reports/", {
        params,
        signal: controller.signal,
      });

      const data = response.data;

      setSearchResults(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const debouncedFilterReport = useMemo(
    () => debounce((search) => fetchFilterReportData(search), 400),
    []
  );
  const handleSearch = (event) => {
    const search_input_report = event.target.value;

    if (search_input_report.length >= 2) {
      debouncedFilterReport(search_input_report);
    } else {
      debouncedFilterReport.cancel();
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
      setSearchResults([]);
    }
  };

  const fetchReportTypes = async () => {
    const response = await api_without_cancellation.get(`${origin}/api/report_types/`);
    if (response.status === 200) {
      setReportTypes(response.data);
    }
  };

  // useEffect(() => {

  // }, [origin]);

  const handleSelectAgency = (report) => {
    setValue("reporting_agency_name", report.reporting_agency);
    setValue("address", report.address1);
    setValue("address1", report.address2);
    setValue("city", report.city);
    setValue("state", report.state);
    setValue("zip", report.zip);
    setValue("email", report.email);
    setValue("phone", formatPhoneNumber(report.phone));
    setValue("extension", report.extension);
    setValue("fax", formatPhoneNumber(report.fax));
    setValue("website", report.website);
    setValue("contact_title", report.contact_title);
    setValue("contact_first_name", report.contact_first_name);
    setValue("contact_last_name", report.contact_last_name);
    // reset({
    //   reporting_agency_name: report.reporting_agency,
    //   address: report.address,
    //   address1: report.address1,
    //   city: report.city,
    //   // state: report.state,
    //   zip: report.zip,
    //   email: report.email,
    //   phone: report.phone,
    //   extension: report.extension,
    //   fax: report.fax,
    //   // contact_title: report.title,
    //   contact_title: report.contact_title,
    //   contact_first_name: report.contact_first_name,
    //   contact_last_name: report.contact_last_name,
    // });
    // selectedState.current = report.state;
    setSearchResults([]);
  };

  const formatNumber = (value) => {
    if (!value) return value;

    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  useEffect(() => {
    // fetchFilterReportData();
    fetchStatesData();
    fetchReportTypes();
    if (report) {
      setValue("report_id", report?.id);
      setValue("reporting_agency_name", report.reporting_agency_name || "");
      setValue("for_reporting_agency", report.for_reporting_agency || "");
      setValue("address", report.address || "");
      setValue("address1", report.address1 || "");
      setValue("city", report.city || "");
      setValue("zip", report.zip_code || "");
      setValue("state", report?.state);
      setValue("phone", formatNumber(report.phone) || "");
      setValue("extension", report.extension || "");
      setValue("fax", formatNumber(report.fax) || "");
      setValue("email", report.email || "");
      // setValue("state", report.state || "");

      //////// report-info-panel data
      setValue("report_typeID", report.report_typeID || "");
      setValue("contact_title", report.contact_title || "");
      setValue("contact_first_name", report.contact_first_name || "");
      setValue("contact_last_name", report.contact_last_name || "");

      setValue("date_taken", formatCalendarDateForInput(report.date_taken) || "");
      setValue("report_taken", report.report_taken || false);
      setValue("is_blocked", report.is_blocked || false);
      setValue("completed", formatCalendarDateForInput(report.completed) || "");
      setValue("cost", report.cost || 0);

      // report-taken-by
      setValue("report_number", report.report_number || "");
      setValue("report_requested", formatCalendarDateForInput(report.date_ordered) || "");
      setValue("report_received", formatCalendarDateForInput(report.date_recieved) || "");
      // reset({
      //   reporting_agency_name: report.reporting_agency_name || "",
      //   for_reporting_agency: report.for_reporting_agency || "",
      //   address: report.address || "",
      //   address1: report.address1 || "",
      //   city: report.city || "",
      //   zip: report.zip_code || "",
      //   phone: formatNumber(report.phone) || "",
      //   extension: report.extension || "",
      //   fax: formatNumber(report.fax) || "",
      //   email: report.email || "",
      //   // state:report.state || "",

      //   ////////repot-info-panel-data-filled here

      //   report_typeID: report.report_typeID || "",
      //   contact_title: report.contact_title || "",
      //   contact_first_name: report.contact_first_name || "",
      //   contact_last_name: report.contact_last_name || "",

      //   ///OLD
      //   // title: report.title || "",
      //   // reporter_firstname: report.reporter_firstname || "",
      //   // reporter_lastname: report.reporter_lastname || "",

      //   date_taken: formatDate(report.date_taken) || "",
      //   report_taken: report.report_taken || false,
      //   is_blocked: report.is_blocked || false,
      //   completed: formatDate(report.completed) || "",
      //   cost: report.cost || 0,

      //   //fill the report-taken-by data
      //   report_number: report.report_number || "",
      // });
      setSelectedReportTypeID(Number(report.report_typeID));
      // selectedState.current = report.state;
    }
  }, [report, reset, origin]);

  useEffect(() => {
    const handler = (e) => {
      if (reportTypeRef.current && !reportTypeRef.current.contains(e.target)) {
        setReportTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    setValue("report_typeID", selectedReportTypeID);
  }, [selectedReportTypeID, setValue]);
  async function postDataforUpdateReportAgency(data) {
    const response = await api_without_cancellation.put(
      `/api/update_report/${getClientId()}/${getCaseId()}/`,
      data
    );
    if (response.status === 200) {
      handleClose();
      onFetchReports();
    }
  }

  //remove bracktes and spaces from  numbers
  const stripNumberFormatting = (number) => {
    return number.replace(/[^\d]/g, "");
  };

  const onSubmit = (data) => {
    // setShouldSubmit(true)
    const cleanedData = {
      ...data,
      phone: stripNumberFormatting(data.phone), //removes prenthesis and spaces form value
      fax: stripNumberFormatting(data.fax),
      address: data.address || "",
      address1: data.address1 || "",
      completed: data.completed || null,
      date_taken: data.date_taken || null,
      state: data.state, // this field is tracked with useRef
    };

    cleanedData["is_blocked"] = dummy;
    try {
      postDataforUpdateReportAgency(cleanedData);
      onFetchReports();
    } catch (error) {
      console.error(error);
    }
  };
  const selectedReportType = reportTypes?.find((rt) => rt.id === selectedReportTypeID);
  const [costFocused, setCostFocused] = useState(false);
  const costValue = watch("cost");
  // const [costFocused, setCostFocused] = useState(false);
  const [previousCost, setPreviousCost] = useState("");
  return (
    <FormProvider {...methods}>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName=" modal-dialog-centered max-800p custom-insurance-dialog"
      >
        <div>
          <Modal.Header
            style={{ borderBottom: "0px" }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              Edit Report
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <div className="custom-tab m-t-5">
              <Tab.Container defaultActiveKey={activeTab}>
                <Nav variant="tabs" className="justify-content-around">
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-before"
                    eventKey="report-information"
                  >
                    Report Information
                  </Nav.Link>

                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                    eventKey="reporting-agency"
                  >
                    Reporting Agency
                  </Nav.Link>

                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-after"
                    eventKey="report-taken-by"
                  >
                    Report Taken By
                  </Nav.Link>
                </Nav>
                <Form
                  id="Reports_form "
                  className="d-flex , flex-column justify-content-between"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div
                    style={{
                      minHeight: "350px",
                    }}
                    className=" m-t-5"
                  >
                    <Tab.Content>
                      <Tab.Pane
                        style={{
                          minHeight: "350px",
                          overflow: "hidden",
                        }}
                        eventKey="reporting-agency"
                      >
                        <Row
                          style={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                          }}
                          className="mx-0"
                        >
                          <Col md={12} style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                            <input
                              type="text"
                              placeholder="Type Reporting agency name or address to search directory then click an entry"
                              className="form-control custom-margin-bottom height-25 p-0 p-l-5 rounded-0"
                              name="reporting_agency_search_form"
                              value={reportSearchInput}
                              onChange={(e) => {
                                setReportSearchInput(e.target.value);
                                handleSearch(e);
                              }}
                            />
                            {reportSearchInput && (
                              <span
                                onClick={() => {
                                  setReportSearchInput("");
                                  handleSearch({ target: { value: "" } });
                                  reset({
                                    reporting_agency_name: "",
                                    address: "",
                                    address1: "",
                                    city: "",
                                    state: "",
                                    zip: "",
                                    email: "",
                                    phone: "",
                                    extension: "",
                                    fax: "",
                                    website: "",
                                    contact_title: "",
                                    reporter_firstname: "",
                                    reporter_lastname: "",
                                  });
                                  setSelectedReportTypeID(Number(0));
                                }}
                                style={{
                                  position: "absolute",
                                  right: "15px",
                                  top: "5px",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  color: "black",
                                  lineHeight: 1,
                                  userSelect: "none",
                                }}
                              >
                                ✕
                              </span>
                            )}
                            {searchResults.length > 0 && (
                              <AutoCompleteSearch
                                searchedInsurances={searchResults}
                                selectedInsurance={(data) => handleSelectAgency(data)}
                                isReport2={true}
                              />
                            )}
                          </Col>
                        </Row>
                        {/* <Row className="mx-0 " style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                          <Col
                            md={12}
                            className="mx-0"
                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                          >
                            <input
                              type="text"
                              placeholder="Type Reporting agency name or address to search directory then click an entry"
                              className="form-control mb-1"
                              name="reporting_agency_search_form"
                              onChange={handleInputChange}
                            />
                            {Array.isArray(filteredResults) && filteredResults.length > 0 && (
                              <div style={{ position: "relative" }}>
                                <div
                                  className={`${isFiltersOpen ? "block" : "hidden"}`}
                                  style={{
                                    position: "absolute",
                                    zIndex: 1000,
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc",
                                    width: "100%",
                                    maxHeight: "150px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {filteredResults.map((result, index) => (
                                    <div
                                      key={index}
                                      onClick={() => {
                                        handleSelectAgency(result);
                                        setIsFiltersOpen(false);
                                      }}
                                      style={{
                                        padding: "8px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      {result.name} {result.address} {result.address1} {result.city}{" "}
                                      {result.state}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </Col>
                        </Row> */}
                        <Row className="align-items-center custom-margin-bottom mx-0 ">
                          <Col md={12} className="mx-0 ps-0 pe-0">
                            {/* <div className="row align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">Agency:</span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="text"
                                  placeholder="Enter Reporting Agency"
                                  className="form-control"
                                  {...register("reporting_agency_name")}
                                />
                             
                              </div>
                            </div> */}
                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-12 p-l-5 p-r-5">
                                <input
                                  type="text"
                                  placeholder="Enter Reporting Agency"
                                  className="form-control height-25 p-l-5 p-0 d-flex align-items-center justify-content-center"
                                  {...register("reporting_agency_name")}
                                />
                              </div>
                            </div>
                            <GenericContactTabForHookForm
                              statesAbrs={statesAbrs}
                              // selectedState={selectedState.current}
                            />
                          </Col>
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane
                        style={{
                          minHeight: "350px",
                        }}
                        eventKey="report-information"
                      >
                        <Row
                          style={{
                            minHeight: "350px",
                          }}
                          className="mx-0"
                        >
                          <Col md={12} className="p-0">
                            {/* <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-12">
                                <select
                                  className="form-select form-control height-25 d-f"
                                  {...register("report_typeID")}
                                >
                                  {reportTypes &&
                                    reportTypes.map((reportType) => (
                                      <option
                                        key={reportType.id}
                                        value={reportType.id}
                                        selected={reportType.id === selectedReportTypeID}
                                      >
                                        {reportType.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div> */}
                            <div className="d-flex mx-0 align-items-center custom-margin-bottom">
                              <div
                                ref={reportTypeRef}
                                className="col-md-5   p-l-5 p-r-5  custom-select-new-provider"
                              >
                                <div
                                  className="dropdown-button form-control pt-0 pb-0 pe-0 rounded-0 height-25 d-flex align-items-center"
                                  onClick={() => setReportTypeDropdown((p) => !p)}
                                  style={{
                                    paddingLeft: selectedReportType ? "0px" : "5px",
                                    background: "white",
                                  }}
                                >
                                  <span>
                                    {selectedReportType ? (
                                      <div
                                        className="d-flex p-l-5 align-items-center"
                                        style={{
                                          height: "25px",
                                          fontSize: "14px",
                                          color: "black",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {selectedReportType.name}
                                      </div>
                                    ) : (
                                      "Select Report Type"
                                    )}
                                  </span>
                                </div>
                                {reportTypeDropdown && (
                                  <div
                                    className="dropdown-menu p-0 mt-0"
                                    style={{
                                      width: "281.66px",
                                      left: "5px",
                                      border: "1px solid #ced4da",
                                      // minHeight: "150px",
                                      // maxHeight: "550px",
                                      fontSize: "14px",
                                      overflowY: "auto",
                                      scrollbarWidth: "none",
                                    }}
                                  >
                                    {reportTypes?.map((rt) => (
                                      <div
                                        key={rt.id}
                                        className="dropdown-option d-flex align-items-center height-25"
                                        style={{
                                          cursor: "pointer",
                                          paddingLeft: "5px",
                                          fontWeight: "700",
                                        }}
                                        onClick={() => {
                                          setSelectedReportTypeID(rt.id);
                                          setReportTypeDropdown(false);
                                        }}
                                      >
                                        {rt.name}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <div
                                className="d-flex ps-0 p-r-5 align-items-center justify-content-start"
                                style={{
                                  color: "var(--primary-25)",
                                  fontWeight: "600",
                                  // width: "135px",
                                }}
                              >
                                Report&nbsp;#:
                              </div>
                              <div className="flex-g-1 height-25 ps-0 p-r-5">
                                <input
                                  type="text"
                                  placeholder="Report Number"
                                  className="form-control height-25 p-0 p-l-5 rounded-0"
                                  onFocus={(e) => {
                                    e.target.placeholder = "";
                                    e.target.style.color = "black";
                                  }}
                                  onBlur={(e) => {
                                    e.target.placeholder = "Report Number";
                                  }}
                                  style={{ color: "var(--primary-25)" }}
                                  {...register("report_number")}
                                />
                              </div>
                              <div
                                className="d-flex  ps-0 p-r-5 align-items-center justify-content-start"
                                style={{
                                  color: "var(--primary-25)",
                                  fontWeight: "600",
                                  // width: "135px",
                                }}
                              >
                                Cost:
                              </div>
                              <div
                                className="height-25 p-l-0 p-r-5"
                                style={{
                                  width: "110px",
                                }}
                              >
                                {/* <input
                                  type="number"
                                  step="0.00001"
                                  placeholder="Cost"
                                  className="form-control height-25 p-0 p-l-5 rounded-0"
                                  onFocus={(e) => {
                                    e.target.placeholder = "";
                                    e.target.style.color = "black";
                                  }}
                                  onBlur={(e) => {
                                    e.target.placeholder = "Cost";
                                  }}
                                  style={{ color: "var(--primary-25)" }}
                                  {...register("cost")}
                                /> */}
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  placeholder="Cost"
                                  className="form-control height-25 p-0 p-l-5 rounded-0 text-start"
                                  style={{ color: "var(--primary-25)" }}
                                  value={
                                    costFocused
                                      ? `$ ${costValue ?? ""}`
                                      : costValue !== "" && costValue !== null
                                        ? inputCurrencyFormat2(costValue)
                                        : ""
                                  }
                                  onFocus={(e) => {
                                    e.target.placeholder = "";
                                    e.target.style.color = "black";

                                    // Save current value and clear input
                                    setPreviousCost(costValue);
                                    setValue("cost", "");
                                    setCostFocused(true);
                                  }}
                                  onChange={(e) => {
                                    let value = e.target.value.replace(/[^0-9.]/g, "");

                                    if ((value.match(/\./g) || []).length > 1) {
                                      value = value.substring(0, value.lastIndexOf("."));
                                    }

                                    if (value.includes(".")) {
                                      const parts = value.split(".");
                                      if (parts[1].length > 4) {
                                        parts[1] = parts[1].substring(0, 4);
                                      }
                                      value = parts.join(".");
                                    }

                                    setValue("cost", value);
                                  }}
                                  onBlur={(e) => {
                                    e.target.placeholder = "Cost";
                                    setCostFocused(false);

                                    // If user didn't type anything, restore previous value
                                    if (!costValue) {
                                      setValue("cost", previousCost);
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            {/* <div className="row mx-0 align-items-center custom-margin-bottom">
                            
                            </div> */}
                            <div className="d-flex mx-0 align-items-center custom-margin-bottom">
                              <div
                                className="d-flex p-l-5 align-items-center justify-content-start"
                                style={{
                                  color: "var(--primary-25)",
                                  fontWeight: "600",
                                  // width: "135px",
                                }}
                              >
                                Ready:
                              </div>
                              <div className="flex-g-1 height-25 p-l-5 p-r-5">
                                <input
                                  type="date"
                                  placeholder="Ready (Date of Completion)"
                                  className="form-control height-25 p-0 p-l-5 rounded-0"
                                  onFocus={(e) => {
                                    e.target.placeholder = "";
                                    e.target.style.color = "black";
                                  }}
                                  onBlur={(e) => {
                                    e.target.placeholder = "Ready (Date of Completion)";
                                  }}
                                  style={{ color: "var(--primary-25)" }}
                                  {...register("completed")}
                                />
                              </div>
                              <div
                                className="d-flex p-l-5 align-items-center justify-content-start"
                                style={{
                                  color: "var(--primary-25)",
                                  fontWeight: "600",
                                  // width: "135px",
                                }}
                              >
                                Requested:
                              </div>
                              <div className="flex-g-1 height-25 p-l-5 p-r-5">
                                <input
                                  type="date"
                                  placeholder="Ready (Date of Completion)"
                                  className="form-control height-25 p-0 p-l-5 rounded-0"
                                  onFocus={(e) => {
                                    e.target.placeholder = "";
                                    e.target.style.color = "black";
                                  }}
                                  onBlur={(e) => {
                                    e.target.placeholder = "Ready (Date of Completion)";
                                  }}
                                  style={{ color: "var(--primary-25)" }}
                                  {...register("report_requested")}
                                />
                              </div>

                              <div
                                className="d-flex p-l-5 align-items-center justify-content-start"
                                style={{
                                  color: "var(--primary-25)",
                                  fontWeight: "600",
                                  // width: "135px",
                                }}
                              >
                                Received:
                              </div>
                              <div className="flex-g-1 height-25 p-l-5 p-r-5">
                                <input
                                  type="date"
                                  placeholder="Ready (Date of Completion)"
                                  className="form-control height-25 p-0 p-l-5 rounded-0"
                                  onFocus={(e) => {
                                    e.target.placeholder = "";
                                    e.target.style.color = "black";
                                  }}
                                  onBlur={(e) => {
                                    e.target.placeholder = "Ready (Date of Completion)";
                                  }}
                                  style={{ color: "var(--primary-25)" }}
                                  {...register("report_received")}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="report-information">
                        <Row className="mx-0">
                          <Col md={12} className="p-0">
                            <div className="row mx-0 align-items-center custom-margin-bottom ">
                              <div
                                className="d-flex align-items-center text-start"
                                style={{ marginLeft: "15px" }}
                              >
                                <input
                                  type="checkbox"
                                  className="form-control"
                                  {...register("is_blocked")}
                                  onChange={(e) => setDummy(e.target.checked)}
                                  checked={dummy}
                                />
                                <span
                                  className="d-inline-block text-grey white-space-nowrapping"
                                  style={{ marginLeft: "5px" }}
                                >
                                  Dummy:
                                </span>
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">Type:</span>
                              </div>
                              <div className="col-md-10">
                                <select
                                  className="form-select form-control"
                                  {...register("report_typeID")}
                                >
                                  {reportTypes &&
                                    reportTypes.map((reportType) => (
                                      <option
                                        key={reportType.id}
                                        value={reportType.id}
                                        selected={reportType.id === selectedReportTypeId}
                                      >
                                        {reportType.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>

                            {report?.report_taken ? (
                              <div className="row mx-0 align-items-center custom-margin-bottom">
                                <div className="col-md-2 text-start">
                                  <span className="d-inline-block text-grey white-space-nowrapping">
                                    No Report Taken:
                                  </span>
                                </div>

                                {report?.report_taken ? (
                                  <div className="col-md-6 d-flex ">
                                    <input
                                      type="date"
                                      placeholder="Enter Date Taken"
                                      className="form-control"
                                      {...register("date_taken")}
                                    />
                                    <input
                                      type="checkbox"
                                      placeholder="Enter Date Taken"
                                      className=""
                                      style={{ marginLeft: "20px" }}
                                      {...register("report_taken")}
                                    />
                                  </div>
                                ) : (
                                  <div className="d-flex col-md-2">
                                    <input
                                      style={{ height: "20px" }}
                                      type="checkbox"
                                      placeholder="Enter Date Taken"
                                      className=""
                                      {...register("report_taken")}
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              <></>
                            )}

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey text-nowrap">
                                  Report Number:
                                </span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="text"
                                  placeholder="Enter Report Number"
                                  className="form-control"
                                  {...register("report_number")}
                                />
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">Ready:</span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="date"
                                  placeholder="Enter Date of Completion"
                                  className="form-control"
                                  {...register("completed")}
                                />
                              </div>
                            </div>
                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">Cost:</span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="number"
                                  step="0.01"
                                  placeholder="Enter Cost"
                                  className="form-control"
                                  {...register("cost")}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Tab.Pane> */}

                      <Tab.Pane eventKey="report-taken-by">
                        <Row
                          style={{
                            minHeight: "350px",
                          }}
                          className="mx-0"
                        >
                          <Col md={12} className="p-0">
                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 p-l-5 pe-0">
                                <input
                                  type="text"
                                  placeholder="Title"
                                  className="form-control height-25 d-flex align-items-center p-l-5 p-0"
                                  {...register("contact_title")}
                                  // {...register("contact_title")}
                                />
                              </div>

                              <div className="col-md-5 p-l-5 pe-0">
                                <input
                                  type="text"
                                  placeholder="First Name"
                                  className="form-control height-25 d-flex align-items-center p-l-5 p-0"
                                  {...register("contact_first_name")}
                                  // {...register("contact_first_name")}
                                />
                              </div>

                              <div className="col-md-5 p-l-5 p-r-5">
                                <input
                                  type="text"
                                  placeholder="Last Name"
                                  className="form-control height-25 d-flex align-items-center p-l-5 p-0"
                                  {...register("contact_last_name")}
                                  // {...register("contact_last_name")}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="report-taken-by">
                        <Row className="mx-0 mt-3">
                          <Col md={12} className="p-0">
                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">
                                  <nobr>Title:</nobr>
                                </span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="text"
                                  placeholder="Enter Title"
                                  className="form-control"
                                  // {...register("title")}
                                  {...register("contact_title")}
                                />
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">First:</span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="text"
                                  placeholder="Enter First Name"
                                  className="form-control"
                                  // {...register("reporter_firstname")}
                                  {...register("contact_first_name")}
                                />
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">Last:</span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="text"
                                  placeholder="Enter Last Name"
                                  className="form-control"
                                  // {...register("reporter_lastname")}
                                  {...register("contact_last_name")}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Tab.Pane> */}
                    </Tab.Content>
                  </div>
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      padding: "5px",
                    }}
                  >
                    <Button
                      className="button-padding-footer-new-provider height-25 d-flex align-items-center justify-content-center"
                      variant="secondary"
                      onClick={handleClose}
                      type="button"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      onClick={onShowDeleteConfirmPopup}
                      className="button-padding-footer-new-provider height-25 d-flex align-items-center justify-content-center"
                    >
                      Delete
                    </Button>
                    <Button
                      variant="success"
                      className="button-padding-footer-new-provider height-25 d-flex align-items-center justify-content-center"
                      type="submit"
                    >
                      Save and Close
                    </Button>
                  </div>
                </Form>
              </Tab.Container>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* {showDeleteConfirm && (
        <ConformDeletePopup handleDeleteSubmission={handleDeleteSubmission} handleClose={hideDeleteConfirmPopup} />
      )} */}
    </FormProvider>
  );
}

export default EditReportModal;
